import { create } from 'zustand'
import * as api from '../services/api'

const useNotificationStore = create((set, get) => ({
  notifications: [],
  unreadCount: 0,
  isLoading: false,
  pollingInterval: null,

  // Fetch full notification list
  fetchNotifications: async (limit = 50) => {
    set({ isLoading: true })
    try {
      const response = await api.fetchNotifications(limit)
      set({
        notifications: response.notifications,
        unreadCount: response.unreadCount,
        isLoading: false
      })
    } catch (error) {
      console.error('Failed to fetch notifications:', error)
      set({ isLoading: false })
    }
  },

  // Fetch just the unread count (for polling)
  fetchUnreadCount: async () => {
    try {
      const response = await api.fetchUnreadNotificationCount()
      set({ unreadCount: response.count })
    } catch (error) {
      console.error('Failed to fetch unread count:', error)
    }
  },

  // Mark specific notifications as read
  markAsRead: async (notificationIds) => {
    try {
      await api.markNotificationsRead({ notificationIds })
      // Update local state
      set(state => ({
        notifications: state.notifications.map(n =>
          notificationIds.includes(n.id) ? { ...n, isRead: true } : n
        ),
        unreadCount: Math.max(0, state.unreadCount - notificationIds.length)
      }))
    } catch (error) {
      console.error('Failed to mark as read:', error)
    }
  },

  // Mark all as read
  markAllAsRead: async () => {
    try {
      await api.markNotificationsRead({ all: true })
      set(state => ({
        notifications: state.notifications.map(n => ({ ...n, isRead: true })),
        unreadCount: 0
      }))
    } catch (error) {
      console.error('Failed to mark all as read:', error)
    }
  },

  // Start polling every 30 seconds
  startPolling: () => {
    const { pollingInterval, fetchUnreadCount } = get()
    if (pollingInterval) return // Already polling

    // Fetch immediately
    fetchUnreadCount()

    // Then poll every 30 seconds
    const interval = setInterval(() => {
      fetchUnreadCount()
    }, 30000)

    set({ pollingInterval: interval })
  },

  // Stop polling
  stopPolling: () => {
    const { pollingInterval } = get()
    if (pollingInterval) {
      clearInterval(pollingInterval)
      set({ pollingInterval: null })
    }
  },

  // Clear notifications (on logout)
  clear: () => {
    const { stopPolling } = get()
    stopPolling()
    set({ notifications: [], unreadCount: 0 })
  }
}))

export default useNotificationStore
